import React, { useRef, useContext, useEffect, useState } from 'react';
import { Icon, Tooltip } from 'antd';
import { Container } from './styles';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_DESIGN_SECTION } from '../../artboard/translationValues';
import { ELEMENTS_DESIGN_SECTION } from '../../containers/ElementsDesignPage/translationValues';

const NAMESPACES = ['DOCUMENT_DESIGN_SECTION', 'ELEMENTS_DESIGN_SECTION'];

const DocumentName = props => {
  const inputRef = useRef(null);
  const [force, setForce] = useState(false);
  const { t } = useTranslation(NAMESPACES);

  const { templateName, onBlur, isElement } = props;

  useEffect(() => {
    if (onBlur) {
      setForce(true);
    }
  }, [templateName, onBlur]);

  useEffect(() => {
    if (force) {
      setForce(false);
    }
  }, [force]);

  const focusInput = () => {
    inputRef.current.focus();
  };

  let valueProps = {};
  if (force) {
    valueProps.value = templateName;
  } else {
    if (props.onBlur === undefined) {
      valueProps.value = `${props.templateName}`;
      valueProps.onChange = e => props.changeTemplateName(e.target.value);
    } else {
      valueProps.defaultValue = `${props.templateName}`;
      valueProps.onBlur = e => props.changeTemplateName(e.target.value);
    }
  }

  return (
    <Tooltip placement="bottom" title={templateName}>
      <Container
        size="large"
        width='250px'
        placeholder={
          props.placeholder || isElement
            ? t(
                `ELEMENTS_DESIGN_SECTION:${ELEMENTS_DESIGN_SECTION.ELEMENT_NAME_PLACEHOLDER.key}`,
                ELEMENTS_DESIGN_SECTION.ELEMENT_NAME_PLACEHOLDER.value,
              )
            : t(
                DOCUMENT_DESIGN_SECTION.TEMPLATE_NAME_PLACEHOLDER.key,
                DOCUMENT_DESIGN_SECTION.TEMPLATE_NAME_PLACEHOLDER.value,
              )
        }
        autoComplete="off"
        name="templateName"
        disabled={force || props.disabled}
        {...valueProps}
        ref={inputRef}
        inverted={props.inverted ? 1 : 0 || 0}
        suffix={ !props.disabled ?
          <Tooltip
            placement="right"
            title={
              isElement
                ? t(
                    `ELEMENTS_DESIGN_SECTION:${ELEMENTS_DESIGN_SECTION.EDIT_ELEMENT_NAME_TOOLTIP.key}`,
                    ELEMENTS_DESIGN_SECTION.EDIT_ELEMENT_NAME_TOOLTIP.value,
                  )
                : t(
                    DOCUMENT_DESIGN_SECTION.EDIT_TEMPLATE_NAME_TOOLTIP.key,
                    DOCUMENT_DESIGN_SECTION.EDIT_TEMPLATE_NAME_TOOLTIP.value,
                  )
            }
          >
            <Icon
              type="edit"
              style={{
                color: props.inverted ? 'rbg(43, 42, 53)' : 'hsla(0, 0%, 100%, 0.4)',
                fontSize: '18px',
              }}
              onClick={focusInput}
            />
          </Tooltip> : <></>
        }
      />
    </Tooltip>
  );
};

export default DocumentName;
